<template>
    <div class="popsale-ad-side">
        <ad-masonry-body v-for="ad in ads" :ad="ad" :key="ad.id"></ad-masonry-body>
    </div>
</template>

<script>
    import AdMasonryBody from "./ad-masonry-body";
    export default {
        components: {AdMasonryBody},
        props: {
            'category': {
                type: Object,
                required: false,
            }
        },
        data: function() {
            return {
                'ads': [],
                'url': '/api/v1/advertise',
                'nextUrl': null,
                'zone': null,
            }
        },
        methods: {
            request: function (url) {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function (response) {
                        this.nextUrl = response.next_page_url;

                        $.each(response.data,function (_, data) {
                            this.ads.push(data);
                        }.bind(this));

                    }.bind(this),
                })
            }
        },
        mounted() {
            this.masonry =$('.popsale-ad-side').masonry({
                itemSelector: '.ad-card',
                columnWidth: '.ad-card',
                horizontalOrder: true,
                percentPosition: true
            });

            if (this.category && this.category.zone_id) {
                this.request(this.url + "?zone=" + this.category.zone_id);
            } else {
                this.request(this.url);
            }
        },
        watch: {
            zone: function (newVal) {
                this.ads = [];
                this.request(this.url + "?zone=" + newVal);
            },
        }
    }
</script>

<style lang="scss">
    .popsale-ad {
        overflow-x: scroll;
        overflow-y: hidden;
    }


    .ad-card {
        position: relative;
        overflow: hidden;
        margin: 5px;

        @media screen and (min-width: 840px) {
            width: calc(100% - 10px);
        }

        @media (max-width: 839px) and (min-width: 480px) {
            width: calc(25% - 10px);
            height: 276px;
        }

        @media (max-width: 479px) {
            width: calc(50% - 10px);
            height: 276px;
        }
    }

    .primary-theme {
        background: var(--mdc-theme-primary);
    }
</style>